module.exports = __webpack_public_path__ + "img/template_3.add2536b.png";